import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import classes from "./UpcomingReservations.module.scss";
import { upcomingReservationsSelector } from "../../../../../redux/selectors/reservationsData";
import { Divider } from "@mui/material";
import { shortMonthsNames } from "../../../../../utils/constants/periodLists";
import { RightChevron } from "../../../../../assets/icons/RightChevron";
import { Typography } from "../../../../../shared/ui/typography";
import { clsx } from "clsx";

export const UpcomingReservations = () => {
  const upcomingReservations: any = useSelector(upcomingReservationsSelector);

  return (
    <div className={classes.upcomingReservContainer}>
      <div className={classes.upcomingReservHeader}>
        <Typography
          variant="text-lg"
          weight="medium"
          className={classes.gray900}
        >
          Upcoming <br /> Reservations
        </Typography>
        <Link className={classes.link} to="/calendar/reservations">
          <Typography
            variant="text-sm"
            weight="medium"
            className={classes.gray900}
          >
            See all
          </Typography>
        </Link>
      </div>
      <div className={classes.reservations}>
        {upcomingReservations &&
          Object.keys(upcomingReservations).map((yearKey: string) => {
            const yearData = upcomingReservations[yearKey];

            return Object.keys(yearData).map((monthKey: string) => {
              const monthData = yearData[monthKey];

              return Object.keys(monthData).map((dateKey: string) => {
                const {
                  checkin_at,
                  nights_count,
                  netincome,
                  guest_count,
                  source,
                } = monthData[dateKey];

                const monthInd = new Date(checkin_at).getUTCMonth();
                const day = new Date(checkin_at).getUTCDate();
                const isPaid: boolean = Boolean(netincome);
                const isOwnerBlock: boolean = source === "owner";

                return (
                  <div
                    className={classes.reservation}
                    key={`reservation_${checkin_at}`}
                  >
                    <div className={classes.reservationContent}>
                      <div className={classes.date}>
                        <div
                          className={clsx(
                            classes.date__innerWrapper,
                            isPaid && classes.paidWrapper,
                            isOwnerBlock && classes.ownerBlockWrapper
                          )}
                        >
                          <Typography
                            variant="text-md"
                            weight="medium"
                            className={classes.gray900}
                          >
                            {day}
                          </Typography>
                          <Typography
                            variant="text-md"
                            weight="medium"
                            className={classes.gray900}
                          >
                            {shortMonthsNames[monthInd]}
                          </Typography>
                        </div>
                      </div>
                      <Divider
                        className={isOwnerBlock ? classes.owner : classes.paid}
                        flexItem
                        orientation="vertical"
                      />
                      <div className={classes.ownerBlocks}>
                        <Typography
                          variant="text-md"
                          weight="medium"
                          className={
                            isOwnerBlock ? classes.blue : classes.green
                          }
                        >
                          {isOwnerBlock ? "Owner Block" : "Paid Reservation"}
                        </Typography>
                        <Typography
                          variant="text-sm"
                          weight="medium"
                          className={classes.green}
                        >
                          {nights_count} Nights &#11044;{" "}
                          {isPaid && `${guest_count} Guests`}
                        </Typography>
                      </div>
                    </div>
                    <Link className={classes.link} to="/calendar/reservations">
                      <RightChevron />
                    </Link>
                  </div>
                );
              });
            });
          })}
      </div>
    </div>
  );
};
